import SeoHead from '../../components/SeoHead';
import { Global, Collection } from '@sourceflow-uk/sourceflow-sdk';
import React from 'react';
import {
    Container,
    Row,
    Col
} from 'reactstrap';
import Link from 'next/link';
import SubBanner from '../../components/SubBanner';
import AllSpecialisms from '../../components/AllSpecialisms';
import Header from '../../components/MainHeader';
import SimplePage from '../../components/SimplePage';

export default function EmployersSpecialisms({
    global,
    all_specialisms
}) {
    return (
        <>
            <SeoHead
                // site_name={`Driving Force`}
                page_name={`Employers - Specialisms | Gap Personnel`}
                // description={``}
                canonical_link={`/employers-specialisms/`}
            />
            <Header />
            <SubBanner
                global={global}
                pathPrefix={`employers_all_specialisms_page.sub_banner`}
                customClass={`mb-5 primary-banner`}
                buttonTitle={`Employers`}
                buttonLink={`/who-we-are/`}
                heading={`Sectors`}
                bannerImageAlt={`Specialisms Banner Image`}
                bannerImageAlt2={`Specialisms Banner Image 2`}
                bannerImage={`/site-assets/images/specialism-img-1.jpg`}
                bannerImage2={`/site-assets/images/specialism-img-2.jpg`}
                dualBannerImage={true}
            />
            <AllSpecialisms
                global={global}
                pathPrefix={`employers_all_specialisms_page.all_specialisms`}
                customClass={`mt-5 pt-5 tertiary-color`}
                all_specialisms={all_specialisms}
                buttonTitle={`View job category`}
                specialismPath={`/employers-specialisms`}
            />
            <SimplePage
                global={global}
                pathPrefix={`employers_all_specialisms_page.simple_page_2`}
                customClass={``}
                content={``}
                formId={`2b1903d0-c09a-4b34-9c3b-27a7b7afb573`}
                heading={`Get in touch`}
                textCenter={true}
            />
        </>
    );
}

export async function getStaticProps({ params }) {
    const global = (await Global()).toJson();
    // const specialisms = await Collection('specialisms');

    // const all_specialisms = specialisms.orderBy('order')
    //     // Pulls parent sector only
    //     .getItems().filter(sector =>
    //         (sector.parent.id === null));

    const employerTag = "Employer";
    const specialisms = (await Collection('specialisms'))
        .filter(function (post) {
            return (
                post.tag?.en.includes(employerTag)
            );
        })
    const all_specialisms = specialisms
    .getItems()
    .filter(sector => sector.specialism_tag === "")
    .sort((a, b) => {
        const aTitle = a.title?.toLowerCase() || '';
        const bTitle = b.title?.toLowerCase() || '';

        if (aTitle === 'other specialisms') return 1;
        if (bTitle === 'other specialisms') return -1;

        if (aTitle === 'other industrial') return 1;
        if (bTitle === 'other industrial') return -1;

        return aTitle.localeCompare(bTitle);
    });

    return {
        props: {
            global,
            all_specialisms
        },
    }
}